"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initForHost = exports.queryEnvironment = exports.uptimeOrderChecks = exports.init = exports.environments = void 0;
/**
 * External CloudFront Distribution Canonical Name
 */
const build_loader_1 = require("./build-loader");
const VALID_FLUID_FILE_TEXT = 'Built with ❤️ by the FLUID Team @ Liberty Mutual';
const DOWNTIME_MESSAGE = (requestedEnvironment, nextEnvironment) => console.debug(`🧪 ${requestedEnvironment.label} is DOWN. Attempting to load FLUID from ${nextEnvironment === null || nextEnvironment === void 0 ? void 0 : nextEnvironment.label}.`);
const UPTIME_MESSAGE = (requestedEnvironment, opts) => console.debug(`🧪 Loading FLUID with from ${requestedEnvironment.label} with options:`, opts);
const ESM = (baseUrl) => `${baseUrl}/fluid/build/fluid.esm.js`;
const LEGACY = (baseUrl) => `${baseUrl}/fluid/build/fluid.js`;
const CSS = (baseUrl) => `${baseUrl}/fluid/build/fluid.css`;
const DOCS = (baseUrl) => `${baseUrl}/fluid/assets/api-docs/api-docs.json`;
/**
 * Add environment switcher (in Angular, use environment.ts and environment.prod.ts to
 * manage environments)
 */
exports.environments = {
    dev: {
        label: 'Development',
        apiDocs: DOCS('https://fluid-development.lmig.com'),
        baseUrl: 'https://fluid-development.lmig.com',
        esm: ESM('https://fluid-development.lmig.com'),
        legacy: LEGACY('https://fluid-development.lmig.com'),
        css: CSS('https://fluid-development.lmig.com'),
        external: false,
    },
    test: {
        label: 'Test',
        apiDocs: DOCS('https://fluid-test.libertymutual.com'),
        baseUrl: 'https://fluid-test.libertymutual.com',
        esm: ESM('https://fluid-test.libertymutual.com'),
        legacy: LEGACY('https://fluid-test.libertymutual.com'),
        css: CSS('https://fluid-test.libertymutual.com'),
        external: true,
    },
    stage: {
        label: 'Staging',
        apiDocs: DOCS('https://fluid-staging.libertymutual.com'),
        baseUrl: 'https://fluid-staging.libertymutual.com',
        esm: ESM('https://fluid-staging.libertymutual.com'),
        legacy: LEGACY('https://fluid-staging.libertymutual.com'),
        css: CSS('https://fluid-staging.libertymutual.com'),
        external: false,
    },
    pre_prod: {
        label: 'Pre-Production',
        apiDocs: DOCS('https://fluid-pre-production.libertymutual.com'),
        baseUrl: 'https://fluid-pre-production.libertymutual.com',
        esm: ESM('https://fluid-pre-production.libertymutual.com'),
        legacy: LEGACY('https://fluid-pre-production.libertymutual.com'),
        css: CSS('https://fluid-pre-production.libertymutual.com'),
        external: true,
    },
    prod: {
        label: 'Production',
        apiDocs: DOCS('https://fluid.libertymutual.com'),
        baseUrl: 'https://fluid.libertymutual.com',
        esm: ESM('https://fluid.libertymutual.com'),
        legacy: LEGACY('https://fluid.libertymutual.com'),
        css: CSS('https://fluid.libertymutual.com'),
        external: true,
    },
    prod_backup: {
        label: 'Production Backup',
        apiDocs: DOCS('https://fluid-backup.libertymutual.com'),
        baseUrl: 'https://fluid-backup.libertymutual.com',
        esm: ESM('https://fluid-backup.libertymutual.com'),
        legacy: LEGACY('https://fluid-backup.libertymutual.com'),
        css: CSS('https://fluid-backup.libertymutual.com'),
        external: true,
    },
    local: {
        label: 'Local',
        apiDocs: DOCS('http://localhost:3333'),
        baseUrl: 'http://localhost:3333',
        esm: ESM('http://localhost:3333'),
        legacy: LEGACY('http://localhost:3333'),
        css: CSS('http://localhost:3333'),
        external: false,
    },
    relative: {
        label: 'via UI Gateway',
        apiDocs: DOCS(''),
        baseUrl: '',
        esm: ESM(''),
        legacy: LEGACY(''),
        css: CSS(''),
    }
};
/**
 * Conditionally load esm or legacy FLUID loader based on browser
 * support.
 *
 * Options Available:
 *
 * useLocal: boolean - if true, FLUID will be loaded from locally running localhost:3333,
 * disableLoader: boolean - if true, the FLUID pre-loader will not be applied.
 * requireExternal: boolean - use if your application is externally facing to ensure FLUIDs external domains are used.
 *
 */
const init = (fluid = exports.environments.prod, opts = { useLocal: false, disableLoader: false, requireExternal: false }) => {
    if (!document.getElementById('fluid-loader-script')) {
        if (!(opts === null || opts === void 0 ? void 0 : opts.disableLoader)) {
            (0, build_loader_1.initialiseLoader)();
        }
        queryEnvironment(fluid, opts);
    }
};
exports.init = init;
const uptimeOrderChecks = (requireExternal = false) => {
    switch (requireExternal) {
        case true: return [
            exports.environments.prod,
            exports.environments.prod_backup,
            exports.environments.pre_prod,
            exports.environments.test,
            exports.environments.stage
        ];
        default: return [
            exports.environments.prod,
            exports.environments.prod_backup,
            exports.environments.pre_prod,
            exports.environments.test,
            exports.environments.stage,
            exports.environments.dev
        ];
    }
};
exports.uptimeOrderChecks = uptimeOrderChecks;
function queryEnvironment(environment = exports.environments.prod, opts) {
    const environmentOrder = (0, exports.uptimeOrderChecks)(opts === null || opts === void 0 ? void 0 : opts.requireExternal);
    findStableEnvironment(environment, environmentOrder, opts).finally();
}
exports.queryEnvironment = queryEnvironment;
function findStableEnvironment(requestedEnvironment, environmentOrder, opts) {
    return __awaiter(this, void 0, void 0, function* () {
        const requestedEnvironmentIdx = environmentOrder.findIndex(env => env.label === requestedEnvironment.label) || -1;
        const nextEnvironmentIdx = requestedEnvironmentIdx + 1;
        const nextEnvironment = environmentOrder[nextEnvironmentIdx];
        try {
            const res = yield fetch(requestedEnvironment.esm);
            res.text().then(text => {
                if (text.indexOf(VALID_FLUID_FILE_TEXT) !== -1) {
                    UPTIME_MESSAGE(requestedEnvironment, opts);
                    addStyleSheet(opts.useLocal ? exports.environments.local : requestedEnvironment);
                    addScriptLoader(opts.useLocal ? exports.environments.local : requestedEnvironment);
                }
                else {
                    DOWNTIME_MESSAGE(requestedEnvironment, nextEnvironment);
                    return findStableEnvironment(nextEnvironment, environmentOrder, opts);
                }
            });
        }
        catch (err) {
            DOWNTIME_MESSAGE(requestedEnvironment, nextEnvironment);
            return findStableEnvironment(nextEnvironment, environmentOrder, opts);
        }
    });
}
/**
 * Allows you to pass an array of hostname matchers which will load the non-prod
 * version of FLUID if the hostname contains any of them, otherwise, will load the production
 * @param nonProdMatchers
 * @param opts
 * @param nonProd
 * @param prod
 */
const initForHost = (nonProdMatchers, opts = { useLocal: false }, nonProd = exports.environments.test, prod = exports.environments.prod) => {
    let environment = opts.useLocal ? exports.environments.local : exports.environments.prod;
    if (window) {
        const hostName = window.location.hostname;
        environment = opts.useLocal ? exports.environments.local : nonProdMatchers.some(matcher => hostName.indexOf(matcher) !== -1) ? nonProd : prod;
    }
    (0, exports.init)(environment, opts);
};
exports.initForHost = initForHost;
/**
 * Creates the script, and adds to document head
 * @param fluid
 */
const addScriptLoader = (fluid) => {
    const script = document.createElement('script');
    script.id = 'fluid-loader-script';
    if ('noModule' in script) {
        script.type = 'module';
        script.src = fluid.esm;
    }
    else {
        script.type = 'text/javascript';
        script.src = fluid.legacy;
    }
    if (!document.getElementById('fluid-loader-script')) {
        document.head.appendChild(script);
        document.body.appendChild(document.createComment(`🧪 Application running the ${fluid.label} build of FLUID.`));
    }
    else {
        console.debug(`🧪 FLUID already loading - skipping script loader.`);
        (0, build_loader_1.removeLoader)();
    }
};
const addStyleSheet = (fluid) => {
    const element = document.createElement('link');
    element.setAttribute('rel', 'stylesheet');
    element.setAttribute('href', fluid.css);
    element.id = 'fluid-base-styles';
    if (!document.getElementById('fluid-base-styles')) {
        document.head.appendChild(element);
    }
};
